/**
 * Mobile sticky add-to-cart bar when the buy box scrolls away.
 */

function getConfig() {
	return window.doneCommerce || {};
}

function formatPrice(amount) {
	const currency = getConfig().currency || '$';
	const value = Number(amount);
	if (!Number.isFinite(value)) {
		return '';
	}
	return `${currency}${value.toFixed(2)}`;
}

function readLivePrice(form) {
	const variationPrice = form
		.closest('.dc-pdp__summary, .summary')
		?.querySelector('.woocommerce-variation-price .amount, .woocommerce-variation-price .price');
	if (variationPrice?.textContent?.trim()) {
		return variationPrice.textContent.trim();
	}

	const summaryPrice = document.querySelector(
		'.dc-pdp__summary .price ins .amount, .dc-pdp__summary .price .amount'
	);
	if (summaryPrice?.textContent?.trim()) {
		return summaryPrice.textContent.trim();
	}

	const dataPrice = form.querySelector('[name="add-to-cart"]')?.closest('[data-product_price]');
	return dataPrice ? formatPrice(dataPrice.dataset.productPrice) : '';
}

function isDrawerOpen() {
	const drawer = document.getElementById('dc-cart-drawer');
	return Boolean(drawer && !drawer.hidden && drawer.classList.contains('is-open'));
}

function createBar(form, button) {
	const bar = document.createElement('div');
	bar.className = 'dc-sticky-atc';
	bar.hidden = true;
	bar.setAttribute('data-sticky-atc', '');

	const price = document.createElement('span');
	price.className = 'dc-sticky-atc__price';
	price.setAttribute('data-sticky-atc-price', '');

	const action = document.createElement('button');
	action.type = 'button';
	action.className = 'dc-btn dc-btn--primary dc-sticky-atc__button';
	action.textContent = button.textContent?.trim() || getConfig().i18n?.addToCart || 'Add to cart';

	action.addEventListener('click', () => {
		if (button.disabled) {
			return;
		}
		button.click();
	});

	bar.append(price, action);
	document.body.appendChild(bar);

	const sync = () => {
		const live = readLivePrice(form);
		price.textContent = live;
		price.hidden = !live;
		action.disabled = Boolean(button.disabled);
		action.textContent = button.textContent?.trim() || action.textContent;
	};

	sync();
	return { bar, sync };
}

export function initStickyAtc() {
	if (!document.body.classList.contains('single-product')) {
		return;
	}

	const form = document.querySelector('.dc-pdp__summary form.cart, .summary form.cart');
	const button = form?.querySelector('.single_add_to_cart_button');
	if (!form || !button) {
		return;
	}

	const mq = window.matchMedia('(max-width: 767px)');
	const { bar, sync } = createBar(form, button);

	const updateVisibility = (inView) => {
		const show = mq.matches && !inView && !button.disabled && !isDrawerOpen();
		bar.hidden = !show;
		document.body.classList.toggle('dc-sticky-atc-visible', show);
	};

	let inView = true;
	const observer = new IntersectionObserver(
		(entries) => {
			inView = Boolean(entries[0]?.isIntersecting);
			updateVisibility(inView);
		},
		{ root: null, threshold: 0, rootMargin: '0px' }
	);
	observer.observe(form);

	mq.addEventListener('change', () => updateVisibility(inView));

	const mutation = new MutationObserver(sync);
	mutation.observe(button, { attributes: true, attributeFilter: ['disabled', 'class'] });

	form.addEventListener('change', sync);
	form.addEventListener('found_variation', sync);
	form.addEventListener('reset_data', sync);
	document.body.addEventListener('added_to_cart', () => {
		window.setTimeout(() => updateVisibility(inView), 0);
	});

	const drawer = document.getElementById('dc-cart-drawer');
	if (drawer) {
		const drawerObserver = new MutationObserver(() => updateVisibility(inView));
		drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['hidden', 'class'] });
	}
}
